<template>
  <div class="common-panel setJudgment-voice-root">
    <question-description :currItem="currItem" :code="currItem.topic_type"></question-description>
    <div class="panel-content">
      <!-- 套题的听力播放按钮 -- 非考试模式显示 -->
      <div class="panel-content-play-con">
        <ButtonTool
          :type="isExamMode ? 'none' : 'play'"
          @click.native="clickPlayTopVoice(true)"
          v-show="topPlayStatus == 'play'"
        ></ButtonTool>
        <ButtonTool
          v-show="topPlayStatus == 'pause' && !isExamMode"
          @click.native="clickPauseTopVoice()"
          type="pause"
          slot="content"
        ></ButtonTool>
      </div>
      <!-- 套题 -->
      <div class="panel-content-details">
        <div
          class="question-item"
          v-for="(item, itemIndex) in filterQuestionList"
          :key="itemIndex"
          :class="{ 'result-mode-quesion-item': !isExamMode }"
        >
          <!-- 小题题干 序号+问题 -->
          <div class="question-item-stem">
            <div class="stem-index-yellow">
              {{ item.is_example ? $('hsk_example') : item.index }}
            </div>

            <div
              v-for="(stemConent, contentNum) in item.screen_text"
              :key="item.index + contentNum"
            >
              <p v-if="stemConent.type == 'text'" class="stem-text">
                {{ stemConent.content }}
              </p>
            </div>
          </div>
          <!-- 小题的选项 -->
          <div class="question-item-answer-con">
            <div
              v-for="option in item.answers"
              :key="`${item.index}_${option.index}`"
              :class="[
                'item-answer',
                {
                  selected: (isExamMode && option.selected) || (item.is_example && item.correct),
                  success: !isExamMode && option.correct,
                  error: !isExamMode && option.selected && !option.correct,
                },
              ]"
              :data-correct="option.correct ? 1 : 0"
              @click="clickQuestionChoice($event, item, option, itemIndex)"
            >
              <div class="item-answer-text">
                <i v-if="option.flag == 'T'" class="el-icon-check judgment-icon"></i>
                <i v-else class="el-icon-close judgment-icon"></i>
              </div>
            </div>
          </div>

          <div
            class="panel-content-result result-correct"
            v-if="
              !isExamMode && !currItem.is_example && item.myAnswerText == item.successAnswerText
            "
          >
            <p class="correct-tips">
              {{ $t('textbook_chioce_word_text_correct_tip') }}
            </p>
          </div>

          <div
            class="panel-content-result result-error"
            v-if="
              !isExamMode && !currItem.is_example && item.myAnswerText != item.successAnswerText
            "
          >
            <p class="error-tips">
              {{ $t('textbook_chioce_word_text_error_tip') }}
            </p>
            <div class="result-show">
              <div class="your-answer">{{ $t('hsk_your_answer') }}{{ item.myAnswerText }}</div>
              <p class="correct-answer">
                {{ $t('hsk_correct_answer') }}{{ item.successAnswerText }}
              </p>
            </div>
            <div class="correct-box" v-if="item.audioText">
              <p class="correct-box-title" v-if="item.audioText">
                {{ $t('hsk_audio_text') }}
              </p>
              <p class="correct-box-answer" v-if="item.audioText">
                {{ item.audioText }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionDescription from '@/components/hsk/questionDescription'
import { VOICE_EXTEND_TIME } from '@/config'

export default {
  components: {
    QuestionDescription,
  },
  data() {
    return {
      changeBtn: false,
      topPlayStatus: 'play',
      startTime: 0,
      middleTime: 0,
    }
  },
  computed: {
    language() {
      let local = localStorage.getItem('language')
      if (local == 'zh') {
        return 'cn'
      } else {
        return local
      }
    },
    filterQuestionList() {
      let questionsList = this.currItem.questions
      //去除例题
      questionsList.map((item, index) => {
        if (this.currItem.answer && this.currItem.answer.length > 0 && !this.changeBtn) {
          for (let i = 0; i < item.answers.length; i++) {
            console.log(item.answers[i], 'item.answers')
            if (item.answers[i].index == this.currItem.answer[index]) {
              item.answers[i].selected = true
              item.myAnswerText = item.answers[i].flag
            } else {
              item.answers[i].selected = false
            }
            if (item.answers[i].correct) {
              item.successAnswerText = item.answers[i].flag
            }
          }
        }
      })

      this.changeBtn = false
      return questionsList
    },
  },
  props: {
    //当前试题项
    currItem: {
      type: Object,
      required: true,
    },
    isExamMode: {
      type: Boolean,
      required: true,
    },
    ansProgressStatus: {
      type: Number,
      required: false,
    },
    baseUrl: {
      type: String,
      default: '',
    },
  },
  watch: {
    ansProgressStatus: {
      handler(val) {
        if (val == 2) {
          this.middleTime = 0
        }
      },
    },
  },
  mounted() {
    this.startTime = this.$player.totalTime
    this.middleTime = this.$player.lastPlayTime
    if (this.ansProgressStatus != 1) {
      this.middleTime = 0
      return
    }

    if (localStorage.getItem('bigIndex') == this.currItem.bigIndex) {
      this.topPlayStatus = 'pause'
    } else {
      this.topPlayStatus = 'play'
    }
  },
  methods: {
    // 小题选项点击事件
    clickQuestionChoice(event, question, option, index) {
      console.log(this.currItem)
      // this.stopAllVoice()
      if (question.is_example) {
        return
      }
      if (!this.isExamMode) {
        return
      }
      const isCorrect = parseInt(event.currentTarget.dataset.correct)
      let questions = this.currItem.questions.map((item) => {
        // 更新重选的答案
        this.$set(this.currItem.answer, index, option.index.toString())
        if (item.index === question.index) {
          // item.playStatus = 'play'
          let questionTemp = {
            ...item,
            ansId: option.index, // 学生作答
            isFinished: true, // 标识已作答
            isCorrect, // 标识是否作答成功
          }
          questionTemp.answers = questionTemp.answers.map((item1) => {
            if (item1.index === option.index) {
              return {
                ...item1,
                selected: true,
              }
            } else {
              return {
                ...item1,
                selected: false,
              }
            }
          })

          return questionTemp
        } else {
          return {
            ...item,
          }
        }
      })

      this.changeBtn = true
      this.currItem.questions = questions
      Object.assign(this.currItem.questions, questions)

      // 作答的对象
      let ansObj = {
        questionId: question.index,
        answer: option.index.toString(),
        judge: isCorrect,
        scores: isCorrect == 1 ? question.score : 0,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
      }

      // 选中后延时1ms再提交
      setTimeout(() => {
        this.$emit('saveRes', ansObj)
      })
    },

    //重置播放状态
    resetPlayStatus(question, status, isclickStatus) {
      let questions = this.currItem.questions.map((item) => {
        console.log(this.currItem)
        let finallyStatus
        if (isclickStatus) {
          finallyStatus =
            item.index === question.currentPlayIndex &&
            this.currItem.bigIndex == question.currentPlayBigIndex
        } else {
          finallyStatus = item.index === question.index
        }
        if (finallyStatus) {
          item.playStatus = status
          console.log(item.playStatus)
          return item
        } else {
          item.playStatus = 'play'
          return {
            ...item,
          }
        }
      })
      this.currItem.questions = questions
      console.log(questions)
    },
    autoPlay(obj, status) {
      this.middleTime = 0
      this.clickPlayTopVoice()
    },
    //停止全部音频，图标都恢复原来的未播放状态
    stopAllVoice() {
      this.currItem.questions.forEach((question) => {
        question.playStatus = 'play'
      })
      this.$player.stop()
    },
    //点击播放顶部录音
    clickPlayTopVoice(status, isTryAgain) {
      if (this.isExamMode && status) return
      this.currItem.questions.forEach((question) => {
        question.playStatus = 'play'
      })
      this.topPlayStatus = 'pause'
      let audioPath = this.baseUrl + this.currItem.top_listen.audio_file
      console.log('题干播放链接===', audioPath)
      this.$player.play(audioPath, '', {}, isTryAgain)
      const _this = this
      this.$player.onended = (e) => {
        this.topPlayStatus = 'play'
        if (e == 'failed') {
          layer.open({
            title: '',
            closeBtn: 0,
            content: _this.$t('common_video_failed'),
            btn: [_this.$t('button_common_start_over'), _this.$t('hsk_skip')],
            yes: (index) => {
              _this.clickPlayTopVoice(false, true)
              layer.close(index)
            },
            btn2: (index) => {
              _this.isExamMode && _this.HSKVoice('HSKVoice', Date.parse(new Date()))
              layer.close(index)
            },
          })
        } else {
          _this.isExamMode && _this.HSKVoice('HSKVoice', Date.parse(new Date()))
        }
      }
      this.$player.onloaded = (e) => {
        this.startTime = e
        this.middleTime = e
      }
      localStorage.setItem('bigIndex', this.currItem.bigIndex)
    },
    //点击暂停顶部录音
    clickPauseTopVoice() {
      this.topPlayStatus = 'play'
      this.$player.pause()
    },
  },
}
</script>

<style lang="scss" scoped>
.common-panel {
  position: relative;

  .panel-content {
    min-height: 540px;
    .panel-content-play-con {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 50px;
    }
    // 套题详情
    &-details {
      padding: 30px;
      .question-item-stem {
        margin-bottom: 16px;
        display: flex;
        .stem-index-yellow {
          background: #3f4651;
          border-radius: 4px;
          color: #fff;
          padding: 5px;
          font-size: 12px;

          min-width: 20px;
          display: flex;
          justify-content: center;
          margin-right: 8px;
        }
        .stem-text {
          color: #2c2f46;
          font-size: 14px;
          padding-top: 2px;
        }
      }

      .question-item-answer-con {
        display: flex;
        .item-answer {
          cursor: pointer;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          color: #696974;
          background: #f2f3f7;
          border-radius: 6px;
          box-sizing: border-box;
          width: 149px;
          height: 40px;
          border-radius: 2px;
          border: 1px;
          margin-right: 20px;
          .judgment-icon {
            font-size: 18px;
            font-weight: bold;
            color: #696974;
          }
        }
      }
      .question-item {
        padding: 8px 0 20px;

        .item-answer {
          &:after {
            position: absolute;
            content: '';
            width: 16px;
            height: 16px;
            right: -24px;
            top: 50%;
            transform: translateY(-50%);
            background-position: 0 0;
            background-repeat: no-repeat;
            background-size: cover;
          }
          &.selected {
            border: 1px solid #faae56;
            background: #ffffff;
            .judgment-icon {
              color: #faae56;
            }
          }
          &.success {
            background: #ffffff; // 设置白色背景
            border: 1px solid rgba(9, 203, 160, 1);
            .judgment-icon {
              color: #09cba0;
            }
          }

          &.error {
            background: #ffffff;
            border: 1px solid #fc5a5a;
            .judgment-icon {
              color: #fc5a5a;
            }
          }
        }
      }
      .result-mode-quesion-item {
        border-top: 1px solid #f2f3f7;
      }
    }

    // 结果
    &-result {
      padding-top: 20px;

      width: 100%;
      &.result-error,
      &.result-correct {
        p.error-tips {
          font-size: 14px;
          color: #fc5a5a;
          margin-bottom: 20px;
        }
        p.correct-tips {
          font-size: 14px;
          color: rgba(9, 203, 160, 1);
          margin-bottom: 20px;
        }
        .result-show {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
        }
        .your-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          img {
            width: 12px;
            height: 12px;
            margin-left: 20px;
          }
        }
        p.correct-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          margin-left: 45px;
        }
        .correct-box {
          background: #fafafb;
          border-radius: 10px;
          padding: 20px;

          &-title {
            font-size: 14px;
            font-weight: bold;
            color: rgba(63, 70, 81, 1);
            margin-bottom: 10px;
          }
          &-answer {
            font-size: 14px;
            font-weight: 400;
            color: rgba(84, 89, 97, 1);
            line-height: 21px;
            margin-bottom: 10px;
            white-space: pre-line;
          }
        }
      }
    }
  }
}
</style>
